import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, Cpu, Network } from 'lucide-react';

export function Features() {
  const { t } = useTranslation();

  const features = [
    {
      icon: Shield,
      title: t('home.features.ddos.title'),
      description: t('home.features.ddos.description')
    },
    {
      icon: Network,
      title: t('home.features.network.title'),
      description: t('home.features.network.description')
    },
    {
      icon: Cpu,
      title: t('home.features.hardware.title'),
      description: t('home.features.hardware.description')
    }
  ];

  return (
    <section className="py-20 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900">{t('home.features.title')}</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-md">
              <feature.icon className="w-12 h-12 text-blue-600 mb-4" />
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}